import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../components/Layout";
import Loader from "../../components/Loader";
import { CrossIcon, DotMenuIcon } from "../../assets/Icons";
import SearchBar from "../../components/SearchBar";
import { useGetStoresQuery } from "../../store/services/storeService";
import { BASE_URL, IMAGE_URL } from "../../Api/constants";
import { useSelector } from "react-redux";
import Modal from "../../components/Modal";
import BannerModel from "../../components/BannerModel";
import { toast } from "react-toastify";
import { getRequest, postRequest } from "../../Api";
import { routes } from "../../Api/routes";
import { capitalizeFirstLetter } from "../../utils/functions";
import RejectedReasonModel from "../../components/RejectedReasonModel";
import { Tooltip } from "antd";
import ActionMenu from "../../components/ActionMenu";
import DataTable from "../../components/DataTable";

const StoreRequests = () => {

  const words = useSelector((state) => state.authReducer.words);
  const lang = useSelector((state) => state.authReducer.lang);
  const navigate = useNavigate();
  const classTextAlign = lang == 'ar' ? 'text-right' : 'text-left';
  const [deleteModal, setDeleteModal] = useState(false);
  const [deletedStoreId, setDeletedStoreId] = useState('');

  const [loading, setLoading] = useState(false);
  const [storesList, setStoresList] = useState([]);
  // const { data: storesList, isLoading: storesLoading } = useGetStoresQuery();

  const [tempData, setTempData] = useState(storesList);
  const [rejectedModel, setRejectedModel] = useState(false);
  const [focusedItemId, setFocusedItemId] = useState();

  const doDeleteStore = async () => {

    setDeleteModal(false);
    setLoading(true);
    const onSuccess = () => {
      toast.success('Store deleted');
      getStores();
      // setLoading(false);
    }

    const onError = () => {
      toast.error('Error while deleting store');
      setLoading(false);
    }

    await postRequest({ id: deletedStoreId }, routes.deleteStore, true, onSuccess, onError);


  }

  const getStores = async () => {

    const onSuccess = (res) => {
      setLoading(false);
      setTempData(res.data);
      setStoresList(res.data);
    }
    const onError = (err) => {
      setLoading(false);
      toast.error('Error while fetching data');
    }

    setLoading(true);
    await getRequest('', routes.getStoreRequests, true, onSuccess, onError);
  }

  const changeStoreStatus = async (status, id, reason) => {

    setRejectedModel(false);
    const onSuccess = (res) => {
      toast.success('Store status updated successfully!');
      if (status == 'approve') {
        return navigate('/dashboard/stores');
      }

      getStores();
    }
    const onError = (err) => {
      setLoading(false);
      toast.error('Error while fetching data');
    }
    const body = {
      status,
      rejected_reason: reason,
      id
    }

    setLoading(true);
    await postRequest(body, routes.changeStoreStatus, true, onSuccess, onError);

  }


  const TableRow = ({ item, index }) => {
    const [hide, setHide] = useState(false);
    useEffect(() => {
      document.body.addEventListener("click", () => {
        document.body.style.overflowY = "auto";
        setHide(false);
      });
    }, []);
    return (
      <tr
        key={index}
        className={`p-2 ${index % 2 === 0 ? "bg-white" : "bg-white"}`}
      >
        <td className="px-2 py-2 text-sm text-black font-medium">
          {item.id}
        </td>
        <td className="px-2 py-2 whitespace-nowrap text-xs text-[#292D32]">
          <div className="flex items-center gap-2">
            <img
              src={
                `${IMAGE_URL}/${item.logo}` ||
                "/images/user1.png"
              }
              alt="userImage"
              className="h-8 w-8 rounded-full object-contain bg-gray-300"
            />
            {item.store_name}
          </div>
        </td>
        <td className={`px-2 py-2 ${classTextAlign} whitespace-nowrap text-xs text-[#292D32]`}>
          {item.store_number}
        </td>
        <td className="px-2 py-2 whitespace-nowrap text-xs text-[#292D32]">
          {item.store_email}
        </td>
        <td className="px-2 py-2 whitespace-nowrap text-xs text-[#292D32]">
          {item.store_id}
        </td>
        <td className="px-2 py-2 whitespace-nowrap text-xs text-[#292D32]">
          <Tooltip
            title={item.current_location}
            arrow
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                maxWidth: 100,
                overflow: 'hidden',
                whiteSpace: 'nowrap', // To ensure text doesn't wrap
                textOverflow: 'ellipsis' // To show ellipsis when text overflows
              }}
            >
              {item.current_location}
            </div>
          </Tooltip>
          {/* {item.current_location} */}
        </td>

        <td className="px-2 py-2 whitespace-nowrap text-xs text-[#292D32]">
          <div
            className={`py-2 px-2 rounded-full text-center font-semibold ${item.status == 'pending'
              ? "bg-[#0DB214]/40 text-[#0DB214]"
              : "bg-red-200 text-red-400"
              }`}
          >
            {capitalizeFirstLetter(item.status)}
          </div>
        </td>
        <td className="px-2 py-2 whitespace-nowrap text-xs text-[#292D32] relative">
          <div className="">
            <div
              className="flex items-center justify-center cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setHide(!hide);
              }}
            >
              <DotMenuIcon />
            </div>
            <div
              className={`menuList-block flex items-center absolute ${hide ? "show" : ""
                }`}
            >
              <div className="menu-item flex items-center flex-col anim">
                <div
                  className="slt flex items-center gap-1 justify-between text-white text-sm"
                  onClick={(e) => {
                    changeStoreStatus('approve', item.id);
                  }}
                >
                  {words['Approve']}
                </div>
                <div
                  className="slt flex items-center gap-1 justify-between text-white text-sm"
                  onClick={(e) => {
                    setFocusedItemId(item.id);
                    setRejectedModel(true);
                  }}
                >
                  {words['Reject']}
                </div>

                <Link
                  to={`/dashboard/request-store-detail/${item.store_id}`}
                  className="slt flex items-center gap-1 justify-between text-white text-sm"
                  onClick={(e) => {
                    setHide(!hide);
                  }}
                >
                  {words['View']}
                </Link>
                <Link
                  to={`/dashboard/edit-store/${item.store_id}`}
                  className="slt flex items-center gap-1 justify-between text-white text-sm"
                  onClick={(e) => {
                    setHide(!hide);
                  }}
                >
                  {words['Edit']}
                </Link>
                <div
                  className="slt flex items-center gap-1 justify-between text-white text-sm"
                  onClick={(e) => {
                    setHide(!hide);
                    setDeleteModal(true);
                    setDeletedStoreId(item.store_id);
                  }}
                >
                  {words['Delete']}
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    );
  };



  const columns = [
    {
      title: words['no'],
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: words['store name'],
      dataIndex: 'type',
      key: 'type',
      render: (_, record) => {
        return (
          <td className="px-2 py-2 whitespace-nowrap text-xs text-[#292D32]">
            <div className="flex items-center gap-2">
              <img
                src={
                  `${IMAGE_URL}/${record?.logo}` ||
                  "/images/user1.png"
                }
                alt="userImage"
                className="h-8 w-8 rounded-full object-contain bg-gray-300"
              />
              {record.store_name}
            </div>
          </td>
        )
      }
    },
    {
      title: words['phone'],
      dataIndex: 'store_number',
      key: 'store_number',
    },
    {
      title: words['email'],
      dataIndex: 'store_email',
      key: 'store_email',
    },
    {
      title: words['id store'],
      dataIndex: 'store_id',
      key: 'store_id',
    },
    {
      title: words['location'],
      dataIndex: 'type',
      key: 'type',
      render: (_, record) => (
        <td className="px-2 py-2 whitespace-nowrap text-xs text-[#292D32]">
          <Tooltip
            title={record.current_location}
            arrow
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                maxWidth: 100,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis'
              }}
            >
              {record.current_location}
            </div>
          </Tooltip>
        </td>
      )
    },


    {
      title: words['status'],
      dataIndex: 'status',
      key: 'status',
      render: (_, record) => (
        <td className="px-2 py-2 whitespace-nowrap text-xs text-[#292D32]">
          <div
            className={`py-2 px-2 rounded-full text-center font-semibold ${record.status == 'pending'
              ? "bg-[#0DB214]/40 text-[#0DB214]"
              : "bg-red-200 text-red-400"
              }`}
          >
            {capitalizeFirstLetter(record.status)}
          </div>
        </td>
      )
    },
    {
      field: "Action",
      title: words["action"],
      render: (value, record) => (
        <ActionMenu
          onAction={(action) => {
            if (action == 'approve') {
              changeStoreStatus('approve', record.id);
            }
            if (action == 'reject') {
              setFocusedItemId(record.id);
              setRejectedModel(true);
            }
            if (action == 'view') {
              return navigate(`/dashboard/store-detail/${record.store_id}`);
            }
            if (action == "edit") {
              return navigate(`/dashboard/edit-store/${record.store_id}`)
            } else if (action === "delete") {
              setDeleteModal(true);
              setDeletedStoreId(record.store_id);
            }
          }}
          menuItems={[
            { label: words['Approve'], action: "approve" },
            { label: words['Reject'], action: "reject" },
            { label: words['View'], action: "view" },
            { label: words['Edit'], action: "edit" },
            { label: words['Delete'], action: "delete" },

          ]}
        />
      ),
    }




  ];



  useEffect(() => {
    getStores();
  }, [])



  return (
    <Layout pageTitle={words['stores']}>
      <div className="store-page min-h-screen flex">
        {/* storesLoading ||  */}
        {loading ? (
          <div className="wrap wrapWidth flex flex-col items-center ">
            <Loader />
          </div>
        ) : (
          <div className="wrap wrapWidth flex flex-col" >
            <div className="flex flex-col gap-5 mt-6">
              <div className="flex items-center justify-between gap-3">
                {/* <div className="flex flex-1">
                  <SearchBar
                    onChange={(v) => {
                      if (!v) {
                        setTempData(storesList);
                        return;
                      };
                      let arr = storesList;
                      arr = arr.filter((e) => e.store_name.toLowerCase().includes(v) || e.store_email.toLowerCase().includes(v.toLowerCase()))
                      setTempData(arr);
                    }}
                  />
                </div> */}
              </div>
              {/* <div className="responsive-table overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200" style={{ minHeight: 150 }} >
                  <thead className="bg-[#F5F7FB]">
                    <tr>
                      <th className={`px-2 py-2 ${classTextAlign} text-sm font-medium text-black tracking-wider`}>
                        {words['no']}
                      </th>
                      <th className={`px-2 py-2 ${classTextAlign} w-56 text-sm text-black font-medium`}>
                        {words['store name']}
                      </th>
                      <th className={`px-2 py-2 ${classTextAlign} text-sm text-black font-medium`}>

                        {words['phone']}
                      </th>
                      <th className={`px-2 py-2 ${classTextAlign} text-sm text-black font-medium`}>

                        {words['email']}
                      </th>
                      <th className={`px-2 py-2 ${classTextAlign} text-sm text-black font-medium`}>

                        {words['id store']}
                      </th>
                      <th className={`px-2 py-2 ${classTextAlign} text-sm text-black font-medium`}>

                        {words['location']}
                      </th>

                      <th className={`px-2 py-2 ${classTextAlign} text-sm text-black font-medium`}>

                        {words['status']}
                      </th>
                      <th className={`px-2 py-2 ${classTextAlign} text-sm text-black font-medium`}>

                        {words['action']}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {tempData?.length && tempData?.map((item, index) => (
                      <TableRow item={item} index={index} />
                    ))}
                  </tbody>
                </table>
              </div> */}
              <div style={{ marginTop: -40 }}>
                <DataTable
                  searchContainerStyle={{ width: "40%", }}
                  data={Array.isArray(tempData) ? tempData : []} columns={columns} />
              </div>



            </div>
          </div>
        )}
      </div>

      <Modal open={deleteModal} setOpen={setDeleteModal}>
        <div className="flex flex-col shadow-md-custom border border-[#D8D8D8] p-4">
          <div className="flex items-center justify-between gap-3">
            <h1 className="text-black text-xl font-medium">{words['Are you sure you want to delete this store?']} </h1>
            <div
              className="flex items-center justify-center h-8 w-8 bg-[#EFEFEF] rounded-full p-1 hover:cursor-pointer"
              onClick={() => setDeleteModal(false)}
            >
              <CrossIcon />
            </div>
          </div>
          <div className="flex row mt-5 justify-end " >
            <div className="flex items-center justify-center">
              <button
                className="button rounded-full !py-2 !px-10"
                onClick={(e) => doDeleteStore()}
              >
                {words['Yes']}
              </button>
            </div>
            <div className="flex items-center justify-center">
              <button
                onClick={() => setDeleteModal(false)}
                className="button rounded-full !py-2 !px-10 ml-2 "
              // onClick={(e) => submitFormData()}
              >
                {words['Cancel']}
              </button>
            </div>
          </div>

        </div>
      </Modal>

      <Modal open={rejectedModel} setOpen={setRejectedModel}>
        <RejectedReasonModel
          openModal={rejectedModel}
          setOpenModal={setRejectedModel}
          onSubmit={(reason) => changeStoreStatus('reject', focusedItemId, reason)}
        />
      </Modal>



    </Layout>
  );
};

export default StoreRequests;
